const formatResultDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${month}/${day}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};

const RESULT_MARKET_LABELS = {
    1: "21 - Yes",
    2: "3CJ (1,2,4) - Yes",
    3: "3CJ (J,Q,K) - Yes",
    4: "Two Red Only",
    5: "Two Black Only",
    6: "Two Even Only",
    7: "Two Odd Only"
};

function resultCardImg(code) {
    return `/assets/images/cards/${code && code !== "1" ? code : "1"}.svg`;
}

function marketWinLabel(val) {
    const n = Number(val);

    if (n === 1) return "WINNER";
    if (n === 0) return "LOSER";

    return val != null && val !== "" ? String(val) : "-";
}

const TrioResults = ({ resultData }) => {
    return (
        <>
            <div className="left-content" style={{ marginRight: "5px", marginLeft: "5px" }}>

                {resultData?.length > 0 &&
                    resultData.map((dataObj, index) => {

                        const cards = [
                            { label: "Left", code: dataObj.ac1 },
                            { label: "Center", code: dataObj.ac2 },
                            { label: "Right", code: dataObj.ac3 }
                        ];

                        const winnerMarkets = [
                            {
                                label: "21 - Yes",
                                win: dataObj.one24
                            },
                            {
                                label: "3CJ (J,Q,K) - Yes",
                                win: dataObj.jqk
                            },
                            {
                                label: "Two Red Only",
                                win: dataObj.twoRed
                            },
                            {
                                label: "Two Black Only",
                                win: dataObj.twoBlack
                            },
                            {
                                label: "Two Even Only",
                                win: dataObj.twoEvenNumber
                            },
                            {
                                label: "Two Odd Only",
                                win: dataObj.twoOddNumber
                            }
                        ].filter(item => Number(item.win) === 1);

                        return (
                            <div
                                key={index}
                                className="card"
                                style={{
                                    border: "1px solid rgb(204, 204, 204)",
                                    borderRadius: "8px",
                                    background: "linear-gradient(rgb(15, 15, 15), rgb(251, 251, 251))",
                                    marginBottom: "0.25rem"
                                }}
                            >
                                <div className="result-header" style={{
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    marginBottom: "12px",
                                    marginTop: "12px",
                                    marginLeft: "12px",
                                }}>
                                    {formatResultDate(dataObj.evt_od)} - <b>ID=</b> {dataObj._id}
                                </div>
                                <div class="card-body" style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "0px" }}>
                                    <div class="players-table" style={{ textAlign: "center", width: "100%" }}>
                                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                            <tbody>
                                                <tr style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-evenly" }}></tr>
                                                <tr
                                                    style={{
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                        justifyContent: "space-evenly", padding: "5px"
                                                    }}
                                                >
                                                    {cards.map((card) => (
                                                        <td key={card.label} className="TdResults">
                                                            <div
                                                                className="player-cards"
                                                                style={{
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "center",
                                                                    overflowWrap: "break-word"
                                                                }}
                                                            >
                                                                <div
                                                                    className="player-name"
                                                                    style={{
                                                                        fontWeight: "bold",
                                                                        textAlign: "center",
                                                                        width: "100%"
                                                                    }}
                                                                >
                                                                    {card.label}
                                                                </div>

                                                                <div
                                                                    className="card-images"
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        gap: "3px",
                                                                        flexWrap: "wrap",
                                                                        width: "100%"
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={resultCardImg(card.code)}
                                                                        alt={card.code}
                                                                        style={{
                                                                            width: "40px",
                                                                            height: "60px"
                                                                        }}
                                                                    />
                                                                </div>

                                                                <div
                                                                    className="player-status bgLoser"
                                                                    style={{
                                                                        color: "#000",
                                                                        marginTop: "5px",
                                                                        fontSize: "14px",
                                                                        fontWeight: "bold",
                                                                        textAlign: "center",
                                                                        width: "100%"
                                                                    }}
                                                                >
                                                                    LOSER
                                                                </div>
                                                            </div>
                                                        </td>
                                                    ))}

                                                    {winnerMarkets.map((market) => (
                                                        <td
                                                            key={market.label}
                                                            className="TdResults TdResultsWin"
                                                        >
                                                            <div
                                                                className="player-cards"
                                                                style={{
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "center",
                                                                    overflowWrap: "break-word"
                                                                }}
                                                            >
                                                                <div
                                                                    className="player-name"
                                                                    style={{
                                                                        fontWeight: "bold",
                                                                        textAlign: "center",
                                                                        width: "100%"
                                                                    }}
                                                                >
                                                                    {market.label}
                                                                </div>

                                                                <div
                                                                    className="card-images"
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        gap: "3px",
                                                                        flexWrap: "wrap",
                                                                        width: "100%"
                                                                    }}
                                                                >
                                                                    <div className="open_cardTP sprite-card-chs-card svg-card_simple_1-dims d-card trans_10 svg-card_simple_omaha_back_bf"></div>
                                                                </div>

                                                                <div
                                                                    className="player-status bgwinner"
                                                                    style={{
                                                                        color: "#000",
                                                                        marginTop: "5px",
                                                                        fontSize: "14px",
                                                                        fontWeight: "bold",
                                                                        textAlign: "center",
                                                                        width: "100%"
                                                                    }}
                                                                >
                                                                    WINNER
                                                                </div>
                                                            </div>
                                                        </td>
                                                    ))}
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </div>
        </>
    );
};

export default TrioResults;